#import "../fragments/form-fragment.graphql"

mutation FormCreateRulesUpdate($input: FormCreateRulesUpdateInput!) {
    formCreateRulesUpdate(input: $input) {
        form {
            ...FormFragment
        }
    }
}
